module.exports = __webpack_public_path__ + "assets/chitai-gorod.ru.9603302795cd7e8b5bdf8eb953980a64152e81f25504010515a95f465bfae123.jpg";